//image
import delBoy from '../../../../images/delBoy.jpg'

const HelloBound = () => {
    return (
      <div className="sm:flex">
        <div className="mb-4 flex-shrink-0 sm:mb-0 sm:mr-4">
          <img src={delBoy} alt="delBoy" width='400px' height='400px'/>
        </div>
        <div>
          <h4 className="text-lg font-bold">Bound Team</h4>
          <p className="mt-1">
            “I wake up every morning and think to myself, 
            ‘how far can I push this company in the next 24 hours.’” – Leah Busque
          </p>
        </div>
      </div>
    )
}

export default HelloBound